import React from "react";
import { Grid, ListItem, ListItemText } from "@mui/material/";
import AssetHistory from "./AssetHistory";
import useAssetHistoryData from "./useAssetHistoryData";
import useAssetData from "./useAssetData";

type Props = {
    auditAssetId: Number,
    onValueChange: Function,
    value: any
};

export default ({ onValueChange }: Props) => {
    const { data } = useAssetData(onValueChange);

    const { history, decisionEntry, latestStatus } = useAssetHistoryData(data);

    return (
        <Grid>
            {/* 1. Asset Decision (Approved/Rejected) */}
            {decisionEntry && (
                <ListItem
                    key={`decision_${decisionEntry.date}_${decisionEntry.heading}`}
                >
                    <ListItemText
                        primary={<AssetHistory assetHistory={decisionEntry} />}
                    />
                </ListItem>
            )}

            {/* 2. Latest Status (Seen/Excluded) */}
            {latestStatus && (
                <ListItem
                    key={`status_${latestStatus.date}_${latestStatus.heading}`}
                >
                    <ListItemText
                        primary={<AssetHistory assetHistory={latestStatus} />}
                    />
                </ListItem>
            )}

            {/* 3. The rest of the history (excluding decision/status so no duplicates) */}
            {data && Array.isArray(history) && history.length > 0
                ? history
                      .filter(
                          (item) =>
                              item !== decisionEntry && item !== latestStatus
                      )
                      .map((item, idx) => (
                          <ListItem
                              key={`list_${idx}_${item.date}_${item.heading}`}
                          >
                              <ListItemText
                                  primary={<AssetHistory assetHistory={item} />}
                              />
                          </ListItem>
                      ))
                : null}
        </Grid>
    );
};
